import React, {forwardRef, useImperativeHandle, useLayoutEffect, useRef, useState} from "react";
import SignatureCanvas from "react-signature-canvas";

const EsignatureField = forwardRef(function EsignatureField({name, required}, ref) {
  const wrapRef = useRef(null);
  const sigPadRef = useRef(null);
  const [dataUrl, setDataUrl] = useState('');
  const [canvasWidth, setCanvasWidth] = useState(320);
  const [showError, setShowError] = useState(false);

  useLayoutEffect(() => {
    if (wrapRef.current?.clientWidth) {
      setCanvasWidth(Math.max(240, Math.min(500, wrapRef.current.clientWidth)));
    }
  }, []);

  const sync = () => {
    const pad = sigPadRef.current;
    if (!pad || pad.isEmpty()) {
      setDataUrl('');
      return;
    }
    let url;
    try {
      url = pad.getTrimmedCanvas().toDataURL('image/png');
    } catch (err) {
      url = pad.getCanvas().toDataURL('image/png');
    }
    setDataUrl(url);
    setShowError(false);
  };

  const handleClear = () => {
    sigPadRef.current?.clear();
    setDataUrl('');
  };

  useImperativeHandle(ref, () => ({
    isEmpty: () => !dataUrl,
    showError: () => setShowError(true),
  }), [dataUrl]);

  return (
    <div ref={wrapRef} style={{maxWidth: 500, marginTop: 8, marginBottom: 8}}>
      <input type="hidden" name={name} className="replacement" value={dataUrl} readOnly/>
      <div style={{
        border: `1px solid ${showError ? '#A33F3B' : 'var(--psb-border-dark, #C7C3D6)'}`,
        borderRadius: 8,
        background: '#fff',
        lineHeight: 0,
      }}>
        <SignatureCanvas
          ref={sigPadRef}
          penColor="#1a1a1a"
          backgroundColor="#ffffff"
          canvasProps={{
            width: canvasWidth,
            height: 150,
            style: {display: 'block', width: '100%', height: 150, cursor: 'crosshair', touchAction: 'none'},
          }}
          onEnd={sync}
        />
      </div>
      <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 4}}>
        <span style={{fontSize: '0.8rem', color: showError ? '#A33F3B' : 'var(--psb-text-muted, #7b809a)'}}>
          {showError ? 'Please sign above.' : (required ? 'Sign above' : 'Sign above (optional)')}
        </span>
        <button
          type="button"
          onClick={handleClear}
          style={{
            border: 'none',
            background: 'none',
            padding: 0,
            fontSize: '0.8rem',
            fontWeight: 600,
            color: 'var(--psb-accent, #B9860F)',
            cursor: 'pointer',
          }}
        >
          Clear
        </button>
      </div>
    </div>
  );
});

export default EsignatureField;
